module.exports = __webpack_public_path__ + "static/Melone-bd02e08b679f51963b36da31e7720804.png";